export default __webpack_public_path__ + "static/media/im-icon.c7ff79d3.svg";